export const TicketTableHeaders = [
  "ticket-title",
  "language",
  "modify",
  "delete",
  "add",
];
